import { Container } from 'pixi.js';
import { BOSS_AT_SECOND, FISH_TABLE, SESSION_SECONDS } from './configs';
export type FishKind = keyof typeof FISH_TABLE;
export type FishType = FishKind;
export interface Fish {
  id: number;
  kind: FishType;
  sprite: Container;
  hp: number;
  maxHp: number;
  reward: number;
  x: number;
  y: number;
  vx: number;
  vy: number;
  width: number;
  height: number;
  speed: number;
  direction: number;
  alive: boolean;
  facingLeft: boolean;
  age: number;
}
let nextId = 1;
export function createFish(kind: FishType, x: number, y: number, elapsed = 0): Fish {
  const spec = FISH_TABLE[kind];
  const speed = spec.speed * (kind === 'small' ? 1 + Math.min(1, elapsed / SESSION_SECONDS) : 1);
  const direction = x < 200 ? 1 : -1;
  return {
    id: nextId++,
    kind,
    sprite: new Container(),
    hp: spec.hp,
    maxHp: spec.hp,
    reward: spec.reward,
    x,
    y,
    vx: speed * direction,
    vy: 0,
    width: spec.width,
    height: spec.height,
    speed,
    direction,
    alive: true,
    facingLeft: direction < 0,
    age: 0,
  };
}
export function stepFish(fish: Fish, dt: number, width: number): boolean {
  fish.x += fish.vx * dt;
  fish.age += dt;
  return fish.x < -fish.width || fish.x > width + fish.width;
}
export function checkHit(a: { x: number; y: number }, ah: number, b: { x: number; y: number }, bh: number): boolean {
  return Math.abs(a.x - b.x) <= (ah + bh) / 2 && Math.abs(a.y - b.y) <= (ah + bh) / 2;
}
export function killFish(fish: Fish, damage: number): number {
  fish.hp = Math.max(0, fish.hp - damage);
  if (fish.hp === 0) {
    fish.alive = false;
    return fish.reward;
  }
  return 0;
}
export function ensureSingleBoss(fishes: Fish[], spawned: boolean, elapsed: number) {
  if (spawned || elapsed < BOSS_AT_SECOND) return { fishes, spawned };
  return { fishes: [...fishes, createFish('boss', 30, 260, elapsed)], spawned: true };
}